<template>
  <img
    class="main_layout_bg sm-hide in_active"
    :src="`/images/games/${currentGameSlug}/banner_bg.webp`"
    loading="eager"
    alt="Boostingmarket.com website background image"
  />
  <div class="d-flex-column justify-start align-start gap-24 mt-20">
    <GamePackBanner />

    <div
      class="d-flex-row align-start space-between xl-row-to-col gap-60 mobile-min-height"
    >
      <div class="d-flex-row flex-15 t-white" style="min-height: 48px">
        <div class="d-flex-column justify-start align-start gap-16">
          <LazyCustomSeasonLengthNew
            v-if="
              showSeasonLength &&
              currentGamePackSlug !== 'path-of-exile-2-leveling-boost'
            "
            :season-length="getGame?.game_season"
          />
          <NestPackSelector />
        </div>
      </div>
      <Poe2Boosting v-if="$route.params.gameSlug === 'path-of-exile-2-boost'" />
      <Fc25Boosting v-if="$route.params.gameSlug === 'fc-boost'" />
    </div>
  </div>
  <div
    class="d-flex-row justify-end"
    v-if="currentGamePackSlug === 'path-of-exile-2-boost'"
  >
    <div
      class="d-flex-column justify-start flex-825 flex-lg-10"
      style="margin-top: 30px"
    >
      <div class="d-flex-column gap-0">
        <p
          class="t-orange regular-l f-w-500 font-family-1"
          style="letter-spacing: 2px"
        >
          {{ $t("homepage.faq") }}
        </p>
        <h2
          class="t-white font-family-1 title-h2 f-w-600"
          style="text-align: center"
        >
          {{ $t("homepage.got_a_question") }}
          <br />
          {{ $t("homepage.we_have")
          }}<span class="t-light-orange">{{ $t("homepage.answers") }}</span
          >!
        </h2>
      </div>

      <div class="d-flex-row align-start lg-row-to-col">
        <div class="d-flex-column gap-5">
          <Faq :faqs="[...gameFaqs].splice(0, 4)" variant="pack twocol" />
        </div>
        <div class="d-flex-column gap-5">
          <Faq :faqs="[...gameFaqs].splice(4, 6)" variant="pack twocol" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import NestPackSelector from "../sections/boosting/NestPackSelector.vue";
import GamePackBanner from "../banners/GamePackBanner.vue";
import Poe2Boosting from "./Poe2Boosting.vue";
import Fc25Boosting from "./Fc25Boosting.vue";
import Faq from "../custom/Faq.vue";

const { currentGamePackSlug, currentGameSlug } = useGameComposable();
const { getLocale } = useFunctions();
const gameStore = useGameStore();

const { setGamePack, getGamePack, apiGetGame, getGame, apiGetGameRanks } =
  useGameStore();
const categoryData = ref(null);
const router = useRouter();
const route = router.currentRoute;
const localePath = useLocalePath();

const showSeasonLength = computed(() => {
  if (!getGame?.id) return false;
  if (getGame?.game_season?.id) return true;
  return false;
});

const gameFaqs = computed(() => {
  if (gameStore.getGame?.faqs) {
    return gameStore.getGame?.faqs;
  }
  return [];
});

const isNotNested = computed(() => {
  if (getGamePack.child_packs?.length > 0) return false;
  return true;
});
</script>
